import { BI_SCHEMA } from '../../utils/bi-logger/bi-events';
import { biLoggerActionCreator } from '../../utils/bi-logger/bi-logger';
export var sendLoginBiEvent = function () {
    return biLoggerActionCreator({
        event: BI_SCHEMA.loginPage.signIn.click,
        params: {
            referralUrl: document.referrer || '',
        },
    });
};
